import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  EffectCreative,
  EffectFade,
  Manipulation,
} from 'swiper/modules';

new Swiper('#shop-my-slider', {
  modules: [Navigation, Pagination],
  slidesPerView: 1,
  spaceBetween: 40,
  navigation: {
    prevEl: '#shop-my-slider-nav .prev',
    nextEl: '#shop-my-slider-nav .next',
  },
  breakpoints: {
    768: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 4,
    },
  },
});

new Swiper('#wishlist-slider', {
  modules: [Navigation, Pagination],
  slidesPerView: 2,
  spaceBetween: 24,
  navigation: {
    prevEl: '.wishlist-slider-prev',
    nextEl: '.wishlist-slider-next',
  },
  pagination: {
    el: '.wishlist-pagination',
    clickable: true,
  },
  breakpoints: {
    319: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 10,
    },
    1024: {
      slidesPerView: 1,
      spaceBetween: 0,
    },
    1201: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
  },
});

const cardCreate = new Swiper('.card-create-slider', {
  modules: [Navigation, EffectFade],
  init: false,
  slidesPerView: 1,
  spaceBetween: 40,
  touchRatio: 0,
  effect: 'fade',
  fadeEffect: {
    crossFade: true,
  },
  navigation: {
    prevEl: '.card-create-nav-btn.prev',
    nextEl: '.card-create-nav-btn.next',
  },
  on: {
    slideChange: function (ev) {
      const event = new CustomEvent('changeStep', {
        detail: {
          step: ev.activeIndex + 1,
        },
      });
      document.dispatchEvent(event);
    },
  },
});

const cardSelect = new Swiper('.card-create-select-slider', {
  modules: [Navigation, EffectCreative, Manipulation],
  init: false,
  slidesPerView: 1,
  spaceBetween: 40,
  touchRatio: 1,
  speed: 100,
  effect: 'creative',
  creativeEffect: {
    prev: {
      shadow: false,
      rotate: [0, 0, -12],
      translate: ['-40%', '-30%', 0],
      scale: 0.5,
    },
    next: {
      shadow: false,
      rotate: [0, 0, 12],
      translate: ['40%', '30%', 0],
      scale: 0.5,
    },
    perspective: false,
  },
  navigation: {
    prevEl: '.card-create-select-slider-btn.prev',
    nextEl: '.card-create-select-slider-btn.next',
  },
  on: {
    slideChange: function (ev) {
      const event = new CustomEvent('changeCard', {
        detail: {
          id: ev.slides[ev.activeIndex]?.querySelector('img')?.dataset.cardId,
          url: ev.slides[ev.activeIndex]?.querySelector('img')?.src,
        },
      });
      document.dispatchEvent(event);
    },
  },
});

function setActiveImage() {
  const event = new CustomEvent('changeCard', {
    detail: {
      id: cardSelect.slides[cardSelect.activeIndex]?.querySelector('img')
        ?.dataset.cardId,
      url: cardSelect.slides[cardSelect.activeIndex]?.querySelector('img')?.src,
    },
  });
  document.dispatchEvent(event);
}

function cardStyleSwitch() {
  const cardSwitcher = document.querySelectorAll('[data-card-switch]');
  const cardAllImagesNode = document.querySelectorAll('[data-all-cards] img');

  setActiveImage();
  [...cardSwitcher]?.forEach((r) => {
    r.addEventListener('change', () => {
      const type = r.dataset.cardSwitch;
      const cardAllImages = [...cardAllImagesNode].filter((img) =>
        img.dataset.cardType.includes(type),
      );

      cardSelect.removeAllSlides();

      cardAllImages.forEach((img) => {
        cardSelect.addSlide(
          cardSelect.slides.length,
          `<div class="swiper-slide">${img.outerHTML}</div>`,
        );
      });

      setActiveImage();
    });
  });
}

function initCardSliders() {
  setTimeout(() => {
    cardCreate.init();
  }, 300);
  setTimeout(() => {
    cardSelect.init();
    cardStyleSwitch();
  }, 500);
}

if (document.readyState !== 'loading') {
  initCardSliders();
} else {
  document.addEventListener('DOMContentLoaded', function () {
    initCardSliders();
  });
}

if(document.querySelector('.card-create-select-slider')){
  document
      .querySelector('.card-create-select-slider')
      .addEventListener('click', function (e) {
        if (e.target.tagName === 'IMG') {
          cardCreate.slideNext();
        }
      });
}

new Swiper('#postcards-page-slider', {
  modules: [Navigation, EffectCreative],
  slidesPerView: 1,
  initialSlide: 1,
  spaceBetween: 0,
  effect: 'creative',
  creativeEffect: {
    prev: {
      translate: ['-48%', 0, -500],
    },
    next: {
      translate: ['48%', 0, -500],
    },
  },
  navigation: {
    prevEl: '.postcards-page-prev',
    nextEl: '.postcards-page-next',
  },
});
if (window.innerWidth < 1024){
  new Swiper('#dash-benefits-slider', {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      768: {
        slidesPerView: 2,
      }
    },
    pagination: {
      el: '.dash-benefits-pagination',
      clickable: true,
    },
  });
}

if (window.innerWidth <= 480){
  new Swiper('#dash-rest-slider', {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: {
      480: {
        slidesPerView: "auto",
      },
    },
    pagination: {
      el: '.dash-rest-pagination',
      clickable: true,
    },
  });
}

new Swiper('#dash-act-slider', {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 24,
  breakpoints: {
    768: {
      slidesPerView: "auto",
    },
    1200: {
      slidesPerView: 4,
      spaceBetween: 56,
    },
  },
  pagination: {
    el: '.dash-act-pagination',
    clickable: true,
  },
});

new Swiper('#dash-team-slider', {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 24,
  breakpoints: {
    480: {
      slidesPerView: 2,
    },
    1024: {
      slidesPerView: 3,
    },
    1200: {
      slidesPerView: 5,
    },
  },
  pagination: {
    el: '.dash-team-pagination',
    clickable: true,
  },
});
if (window.innerWidth < 1024) {
  new Swiper('#dash-contacts-slider', {
    modules: [Pagination],
    slidesPerView: 1,
    spaceBetween: 40,
    breakpoints: {
      768: {
        slidesPerView: 2,
      }
    },
    pagination: {
      el: '.dash-contacts-pagination',
      clickable: true,
    },
  });
}

